/*
=============================================================================
COLOR TRANSLATIONS SYSTEM - DOKUMENTATION
=============================================================================

ZWECK:
=======
Diese Datei übersetzt Farbnamen (alle Sprachen) zu deutschen CDN-Bild-Dateinamen.
Wird verwendet für Farbswatches auf Produktseiten.

SYSTEM-ARCHITEKTUR:
==================

1. colorTranslations.js (diese Datei):
   - Enthält getColorTranslation() Funktion
   - Mappt Farbnamen → deutsche Dateinamen
   - Beispiel: "black" → "Schwarz" → lädt "Schwarz.png" vom CDN

2. settings_data.json:
   - Enthält color_swatch_config mit Hex-Codes
   - Beispiel: "Schwarz: #000000"
   - Dient als FALLBACK wenn kein Bild vorhanden ist

3. ngb-swatch.liquid:
   - Ruft getColorTranslation() auf
   - Entscheidet ob Bild oder Hex-Code verwendet wird

WARUM ZWEI SYSTEME?:
===================

BILDER (CDN):
- Zeigt echte Farb-Texturen (z.B. gebürstetes Gold)                     
- Dateinamen sind immer deutsch (z.B. "Gold-gebürstet.png")
- Mehrsprachige Keys führen zum gleichen Bild

HEX-CODES (Fallback):
- Einfache farbige Kreise wenn Bild fehlt
- Garantiert dass immer etwas angezeigt wird

SPRACHEN-UNTERSTÜTZUNG:
=======================
Unterstützte Sprachen: Deutsch, Englisch, Italienisch, Spanisch, 
Französisch, Niederländisch

Beispiel "Gold-gebürstet":
- "gold-gebürstet" → "Gold-gebürstet" (deutsch)
- "gold (brushed)" → "Gold-gebürstet" (englisch)
- "oro spazzolato" → "Gold-gebürstet" (italienisch)
- Alle führen zum gleichen Bild: "Gold-gebürstet.png"

WARUM DEUTSCHE DATEINAMEN?:
===========================
CDN-Bilder haben deutsche Namen aus historischen Gründen.
Das System übersetzt alle Sprachvarianten zu diesen deutschen Dateinamen.

HISTORIE:
=========
Früher: 3000+ Zeilen mit produkt-spezifischen Hardcodings
Jetzt: 128 Zeilen mit sauberer globaler Map

Die produkt-spezifischen Hardcodings waren komplett redundant,
da die globale Map alle Fälle abdeckt.

WARTUNG:
========
Neue Farbe hinzufügen:
1. Bild hochladen (z.B. "NeueFarbe.png")
2. In globalColorMap eintragen (alle Sprachen)
3. settings_data.json wird automatisch aktualisiert

=============================================================================
*/

function getColorTranslation(productId, color) {
  // Globale Farb-Übersetzungstabelle (produktunabhängig)
  // Mappt alle bekannten Farbnamen (alle Sprachen) auf den deutschen CDN-Dateinamen
  var globalColorMap = {
    // Schwarz
    "schwarz": "Schwarz", "black": "Schwarz", "nero": "Schwarz", "negro": "Schwarz", "noir": "Schwarz", "zwart": "Schwarz",
    "color negro": "Schwarz", "colore nero": "Schwarz", "kleur zwart": "Schwarz",
    // Weiß
    "weiß": "Weiß", "weiss": "Weiß", "white": "Weiß", "bianco": "Weiß", "blanco": "Weiß", "blanc": "Weiß", "wit": "Weiß",
    "color blanco": "Weiß", "colore bianco": "Weiß", "kleur wit": "Weiß", "witte kleur": "Weiß",
    // Industrial
    "industrial": "Industrial", "industriale": "Industrial", "industriel": "Industrial", "industrieel": "Industrial",
    // Industrial Anthrazit
    "industrial anthrazit": "Industrial Anthrazit", "industrial anthracite": "Industrial Anthrazit",
    "antracite industriale": "Industrial Anthrazit", "antracita industrial": "Industrial Anthrazit",
    "anthracite industriel": "Industrial Anthrazit", "industriële antraciet": "Industrial Anthrazit",
    "industrieel antraciet": "Industrial Anthrazit",
    // Industrial Silber 
    "industrial silber": "Industrial Silber", "industrial silver": "Industrial Silber",
    "argento industriale": "Industrial Silber", "plata industrial": "Industrial Silber",
    "industrial argent": "Industrial Silber", "industrieel zilver": "Industrial Silber",
    // Antik Gold
    "antik gold": "Antik Gold", "antique gold": "Antik Gold", "oro antico": "Antik Gold",
    "oro antiguo": "Antik Gold", "or antique": "Antik Gold", "antique or": "Antik Gold", "antiek goud": "Antik Gold",
    // Antik Roségold
    "antik roségold": "Antik Roségold", "antique rose gold": "Antik Roségold", "oro rosa antico": "Antik Roségold",
    "oro rosa antiguo": "Antik Roségold", "or rose antique": "Antik Roségold", "antique or rose": "Antik Roségold",
    "antiek roségoud": "Antik Roségold",
    // Rohstahl Silber
    "rohstahl silber": "Rohstahl Silber", "raw steel silver": "Rohstahl Silber",
    "acciaio crudo d'argento": "Rohstahl Silber", "plata bruta de acero": "Rohstahl Silber",
    "acier brut argent": "Rohstahl Silber", "zilver ruw staal": "Rohstahl Silber",
    // Sandschwarz
    "sandschwarz": "Sandschwarz", "sand black": "Sandschwarz", "nero sabbia": "Sandschwarz",
    "negro arena": "Sandschwarz", "noir sable": "Sandschwarz", "zand zwart": "Sandschwarz", "zandzwart": "Sandschwarz",
    "sabbia nera": "Sandschwarz", "noir de sable": "Sandschwarz", "negro de arena": "Sandschwarz",
    // Sandweiß
    "sandweiß": "Sandweiß", "sand white": "Sandweiß", "sabbia bianca": "Sandweiß",
    "arena blanca": "Sandweiß", "blanc sable": "Sandweiß", "zand wit": "Sandweiß",
    // Edelstahl
    "edelstahl": "Edelstahl", "stainless steel": "Edelstahl", "acciaio inossidabile": "Edelstahl",
    "acero inoxidable": "Edelstahl", "acier inoxydable": "Edelstahl", "roestvrij staal": "Edelstahl",
    "in acciaio inox": "Edelstahl", "acciaio inox": "Edelstahl",
    // Edelstahl-Optik
    "edelstahl-optik": "Edelstahl-Optik", "stainless steel look": "Edelstahl-Optik",
    "look acciaio inox": "Edelstahl-Optik", "look in acciaio inossidabile": "Edelstahl-Optik",
    "aspetto acciaio inox": "Edelstahl-Optik", "aspecto de acero inoxidable": "Edelstahl-Optik",
    "aspect acier inoxydable": "Edelstahl-Optik", "roestvrijstalen look": "Edelstahl-Optik",
    // Transparent
    "transparent": "Transparent", "trasparente": "Transparent", "transparente": "Transparent", "transparant": "Transparent",
    // Gold
    "gold": "Gold", "oro": "Gold", "or": "Gold", "goud": "Gold",
    // Gold-gebürstet
    "gold-gebürstet": "Gold-gebürstet", "gold (gebürstet)": "Gold (gebürstet)", "gold brushed": "Gold-gebürstet",
    "gold (brushed)": "Gold (gebürstet)", "oro spazzolato": "Gold-gebürstet", "oro (spazzolato)": "Gold (gebürstet)",
    "cepillado dorado": "Gold-gebürstet", "dorado (cepillado)": "Gold (gebürstet)",
    "brossé or": "Gold-gebürstet", "or (brossé)": "Gold (gebürstet)",
    "goud geborsteld": "Gold-gebürstet", "goud (geborsteld)": "Gold (gebürstet)",
    // Roségold
    "roségold": "Roségold", "rose gold": "Roségold", "oro rosa": "Roségold",
    "or rose": "Roségold", "roségoud": "Roségold",
    // Silber
    "silber": "Silber", "silver": "Silber", "argento": "Silber", "plata": "Silber", "argent": "Silber", "zilver": "Silber",
    // Marineblau
    "marineblau": "Marineblau", "navy blue": "Marineblau", "marina militare": "Marineblau",
    "azul marino": "Marineblau", "bleu marine": "Marineblau", "marineblauw": "Marineblau", "marine": "Marineblau",
    // Blau
    "blau": "Blau", "blue": "Blau", "blu": "Blau", "azul": "Blau", "bleu": "Blau", "blauw": "Blau",
    // Gelb
    "gelb": "Gelb", "yellow": "Gelb", "giallo": "Gelb", "amarillo": "Gelb", "jaune": "Gelb", "geel": "Gelb",
    // Pastellgrün
    "pastellgrün": "Pastellgrün", "pastel green": "Pastellgrün", "verde pastello": "Pastellgrün",
    "verde pastel": "Pastellgrün", "vert pastel": "Pastellgrün", "pastelgroen": "Pastellgrün",
    // Rot
    "rot": "Rot", "red": "Rot", "rosso": "Rot", "rojo": "Rot", "rouge": "Rot", "rood": "Rot",
    // Dunkelrot
    "dunkelrot": "Dunkelrot", "dark red": "Dunkelrot", "rosso scuro": "Dunkelrot",
    "rojo oscuro": "Dunkelrot", "rouge foncé": "Dunkelrot", "donkerrood": "Dunkelrot",
    // Grau
    "grau": "Grau", "gray": "Grau", "grigio": "Grau", "gris": "Grau", "grijs": "Grau",
    // Grün
    "grün": "Grün", "green": "Grün", "verde": "Grün", "vert": "Grün", "groen": "Grün", "groente": "Grün",
    // Rosa
    "rosa": "Rosa", "pink": "Rosa", "rose": "Rosa", "roze": "Rosa",
    // Braun
    "braun": "Braun", "brown": "Braun", "marrone": "Braun", "marrón": "Braun", "marron": "Braun", "bruin": "Braun",
    // Schwarz-Gold
    "schwarz-gold": "Schwarz-Gold", "black-gold": "Schwarz-Gold", "nero-oro": "Schwarz-Gold",
    "negro y dorado": "Schwarz-Gold", "noir et or": "Schwarz-Gold", "zwart-goud": "Schwarz-Gold",
    // Walnuss
    "walnuss": "Walnuss", "walnut": "Walnuss", "noce": "Walnuss", "nogal": "Walnuss", "noix": "Walnuss", "notelaar": "Walnuss",
    // Esche
    "esche": "Esche", "ash": "Esche", "cenere": "Esche", "ceniza": "Esche", "frêne": "Esche", "as": "Esche",
    // Natur
    "natur": "Natur", "nature": "Natur", "natura": "Natur", "naturaleza": "Natur", "natuur": "Natur",
    // Perlmutt-Weiß
    "perlmutt-weiß": "Perlmutt-Weiß", "pearl white": "Perlmutt-Weiß", "madreperla bianca": "Perlmutt-Weiß",
    "blanco perla": "Perlmutt-Weiß", "blanc nacré": "Perlmutt-Weiß", "parelmoer wit": "Perlmutt-Weiß",
    // Perlmutt-Natur
    "perlmutt-natur": "Perlmutt-Natur", "pearl natural": "Perlmutt-Natur", "madreperla naturale": "Perlmutt-Natur",
    "perla natural": "Perlmutt-Natur", "nacré naturel": "Perlmutt-Natur", "parelmoer naturel": "Perlmutt-Natur",
    // Band-Schwarz
    "band-schwarz": "Band-Schwarz", "band black": "Band-Schwarz", "fascia nera": "Band-Schwarz",
    "cinta-negra": "Band-Schwarz", "bande-noire": "Band-Schwarz", "lint-zwart": "Band-Schwarz",
    "ribbon black": "Band-Schwarz", "lint zwart": "Band-Schwarz", "nastro nero": "Band-Schwarz",
    "cinta negra": "Band-Schwarz", "ruban noir": "Band-Schwarz",
    // Band-Weiß
    "band-weiß": "Band-Weiß", "band-weiss": "Band-Weiß", "band white": "Band-Weiß", "fascia bianca": "Band-Weiß",
    "cinta-blanca": "Band-Weiß", "bande-blanche": "Band-Weiß", "lint-wit": "Band-Weiß",
    "ribbon white": "Band-Weiß", "lint wit": "Band-Weiß",
    // Band-Braun
    "band-braun": "Band-Braun", "band braun": "Band-Braun", "band-brown": "Band-Braun",
    "banda marrone": "Band-Braun", "cinta-marrón": "Band-Braun", "marron de bande": "Band-Braun",
    "band-bruin": "Band-Braun", "ribbon brown": "Band-Braun", "lint bruin": "Band-Braun",
    "nastro marrone": "Band-Braun", "cinta marrón": "Band-Braun", "ruban marron": "Band-Braun",
    // Band-Beige
    "band-beige": "Band-Beige", "ribbon beige": "Band-Beige", "nastro beige": "Band-Beige",
    "cinta-beige": "Band-Beige", "bande beige": "Band-Beige", "lint-beige": "Band-Beige"
  };

  var colorLower = color.toLowerCase();
  if (globalColorMap[colorLower]) {
    return globalColorMap[colorLower];
  }

  // Letzter Fallback: Originalfarbe zurückgeben
  return color;
}